import * as React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'
import { Box, CardActionArea } from '@mui/material'

export default function RestaurantCard(props) {
  return (
    <Card
      sx={{
        maxWidth: 280,
        height: 268,
        borderRadius: '16px',
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: 1,
        transition: 'box-shadow .15s ease, transform .15s ease',
        '&:hover': {
          boxShadow: 4,
          transform: 'translateY(-2px)'
        }
      }}>
      <CardActionArea sx={{ height: '100%', alignItems: 'flex-start' }}>
        <Box sx={{ position: 'relative' }}>
          <CardMedia
            component="img"
            height="130"
            image={props.rest.image}
            alt="Restaurant Image"
            sx={{ objectFit: 'cover' }}
          />
          <CardMedia
            component="img"
            alt=""
            image={props.rest.image}
            sx={{
              width: 56,
              height: 56,
              borderRadius: '14px',
              objectFit: 'cover',
              position: 'absolute',
              left: 16,
              bottom: -28,
              border: '3px solid',
              borderColor: 'common.white',
              boxShadow: 2
            }}
          />
        </Box>
        <CardContent sx={{ pt: 4.5, px: 2 }}>
          <Typography
            sx={{
              textDecoration: 'none',
              color: 'text.primary',
              fontWeight: 700,
              fontSize: 15,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
            component="div">
            {props.rest.name}
          </Typography>
          <Typography
            sx={{
              textDecoration: 'none',
              color: 'text.disabled',
              fontSize: 13,
              mt: 0.5,
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden'
            }}>
            {props.rest.address}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}
